import React, { useEffect } from "react";
import "./styles.css";
import Grid from "@mui/material/Unstable_Grid2";
import { AdminNavbar } from "../AdminNavbar/AdminNavbar";
import ClassCard from "../ClassCards/ClassCard";
import apiClient from "../../../utils/api";

interface ClassInfo {
  className?: string;
  professorName?: string;
  professorEmail?: string;
  classID: string;
}
export const Admin: React.FC = () => {
  const [classes, setClasses] = React.useState<ClassInfo[]>([]);
  // Function to convert string[] to ClassInfo[]
  const convertToClassInfo = async (id: string): Promise<ClassInfo> => {
    try {
      const classEntry = await apiClient.classControllerGetById({ classID: id });
      const classMetadataJson = JSON.parse(classEntry.classMetadata);
      return {
        classID: classEntry.id,
        className: classMetadataJson.className,
        professorName: classMetadataJson.professorName,
        professorEmail: classMetadataJson.professorEmail
      };
    } catch (error) {
      console.error("Error fetching class data:", error);
      return { classID: "" }; // Return a default object in case of an error
    }
  };

  useEffect(() => {
    const fetchClassInfoArray = async (classIds: string[]): Promise<ClassInfo[]> => {
      return Promise.all(classIds.map(convertToClassInfo));
    };
    const fetchClassList = async () => {
      try {
        const { classIds } = await apiClient.classControllerList();
        fetchClassInfoArray(classIds).then(classInfoArray => {
          setClasses(classInfoArray);
        });
      } catch(error) {
        console.log("error fetching class card info", error);
      };
    }
    fetchClassList();
  }, []);

  return (
    <Grid container>
      <Grid xs={2}>
        <AdminNavbar />
      </Grid>
      <Grid xs={10}>
        <div className="admin-container">
          <h1 className="header">Welcome to the Admin page!</h1>
          <h2 className="paragraph">view class info below</h2>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {classes &&
              classes.map((classInfo: ClassInfo) => {
                return (
                  <Grid xs={2} sm={4} md={4} key={classInfo.classID}>
                    <ClassCard {...classInfo} />
                  </Grid>
                );
              })}
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};
